var _circle, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVanilla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 135,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 64,
    r: 56,
    fill: "url(#paint0_radial_liquidity)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a_liquidity",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 10,
    width: 108,
    height: 108
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 64,
    r: 54,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a_liquidity)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.426 48.4985C189.702 51.5 189.702 59 189.702 63.1822C189.702 72 189.003 84.2118 179.612 95.1043C162.5 127.5 129.735 129.035 115.5 124.5C101.265 119.965 84.4353 94.9851 82.1972 81.3249C79.9592 67.6647 79 63.423 79 63.423C79 63.423 82.0832 85.3617 97.3271 85.3617C112.571 85.3617 138.001 65.4767 152.008 57.781C166.015 50.0853 177.5 40.3201 186.426 48.4985Z",
    stroke: "url(#paint2_linear_liquidity)",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.702 63.1822C189.702 59 189.702 51.5 186.426 48.4985C179.094 41.7807 170.036 47.1697 159.271 53.5738C156.931 54.9662 154.51 56.4066 152.008 57.781C148.271 59.8343 143.72 62.7554 138.767 65.9349C136.286 67.5278 133.703 69.1854 131.072 70.8314C126.181 67.692 121.689 64.812 117.992 62.781C103.985 55.0853 89.5063 51.7232 83.6653 59.4747C82.0152 61.6646 81.0489 68.423 82.0976 72.4837C82.2652 73.1327 82.3912 73.7972 82.4888 74.4775C80.9863 71.4209 80.0774 68.3556 79.5658 66.2308C79.1799 64.2187 79 63.423 79 63.423C79 63.423 79.1546 64.5232 79.5658 66.2308C80.0708 68.8642 80.9285 73.5812 82.1972 81.3249C82.4698 82.9886 82.9589 84.8203 83.6333 86.7625C84.3903 90.5407 85.9744 94.642 89.5342 99.0784C96.2653 110.375 106.412 121.605 115.5 124.5C128.359 128.596 156.34 127.74 174.243 103.654C181.402 98.0083 186.895 91.8664 187.803 86.3249C188.049 84.8203 188.298 83.5097 188.547 82.3687C191.415 78.6351 192.5 75 192.5 75C192.5 75 190.553 73.1508 188.547 82.3687C187.77 83.38 186.862 84.3985 185.809 85.354C189.352 77.3772 189.702 69.4283 189.702 63.1822Z",
    fill: "url(#paint3_linear_liquidity)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6653 59.4747C82.0152 61.6646 82.6166 70.9393 83.6653 75C85.5294 82.218 86.293 89.7413 96 101C109.529 116.692 131.265 126.035 145.5 121.5C159.735 116.965 185.565 99.9851 187.803 86.3249C190.041 72.6647 192.5 75 192.5 75C192.5 75 187.917 90.3617 172.673 90.3617C157.429 90.3617 131.999 70.4767 117.992 62.781C103.985 55.0853 89.5063 51.7232 83.6653 59.4747Z",
    fill: "url(#paint4_radial_liquidity)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6653 59.4747C82.0152 61.6646 82.6166 70.9393 83.6653 75C85.5294 82.218 86.293 89.7413 96 101C109.529 116.692 131.265 126.035 145.5 121.5C159.735 116.965 185.565 99.9851 187.803 86.3249C190.041 72.6647 192.5 75 192.5 75C192.5 75 187.917 90.3617 172.673 90.3617C157.429 90.3617 131.999 70.4767 117.992 62.781C103.985 55.0853 89.5063 51.7232 83.6653 59.4747Z",
    fill: "url(#paint5_radial_liquidity)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6653 59.4747C82.0152 61.6646 82.6166 70.9393 83.6653 75C85.5294 82.218 86.293 89.7413 96 101C109.529 116.692 131.265 126.035 145.5 121.5C159.735 116.965 185.565 99.9851 187.803 86.3249C190.041 72.6647 192.5 75 192.5 75C192.5 75 187.917 90.3617 172.673 90.3617C157.429 90.3617 131.999 70.4767 117.992 62.781C103.985 55.0853 89.5063 51.7232 83.6653 59.4747Z",
    stroke: "url(#paint6_linear_liquidity)",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_liquidity",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-91.637 140.2891 16.3025) scale(122.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_liquidity",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-21.5 45.50005 -74.3685 -35.14113 167 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_liquidity",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.49998 36.50005 -59.07539 8.90173 91.5 45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_liquidity",
    x1: 99.5,
    y1: 82.5,
    x2: 170.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80196",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4688,
    stopColor: "#F80196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#F80196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_liquidity",
    x1: 144.5,
    y1: 104.338,
    x2: 190.615,
    y2: 54.6446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002EFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_liquidity",
    x1: 103,
    y1: 67.5,
    x2: 178.5,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80196",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanilla);
export default __webpack_public_path__ + "static/media/vanilla.0d74e29466f54d2a7567166dac7eb1f3.svg";
export { ForwardRef as ReactComponent };